// All bilingual EN/ES copy lives here.

export const translations = {
    en: {
        common: {
            bookNow: "Book Now",
            bookConsultation: "Book Consultation",
            depositNote: "$50 non-refundable deposit required",
            learnMore: "Learn More",
            viewService: "View Service",
            gallery: "Gallery",
            seeAllReviews: "Read All Reviews",
            faqTitle: "Frequently Asked Questions",
            phone: "Phone",
            address: "Address",
            hours: "Studio Hours",
            email: "Email",
            instagram: "Instagram",
            sendMessage: "Send Message",
            submit: "Submit Inquiry",
            submitting: "Submitting…",
            thankYou: "Thank you — we'll be in touch soon.",
            errorSubmit: "Something went wrong. Please try again or call us.",
            requiredField: "Required",
            optional: "Optional",
            byAppointment: "By appointment",
        },
        nav: {
            home: "Home",
            services: "Services",
            nanoBrows: "Nano Brows",
            powderBrows: "Powder Brows",
            lipBlushing: "Lip Blushing",
            microblading: "Microblading",
            eyelinerTattoo: "Eyeliner Tattoo",
            browLamination: "Brow Lamination",
            comboBrows: "Combo Brows",
            lashes: "Lash Lifts",
            tattoos: "Body Tattoos",
            aftercare: "Aftercare",
            bedRentals: "Bed Rentals",
            training: "Training",
            about: "About",
            contact: "Contact",
        },
        trust: {
            stars: "5.0 Stars · 30+ Google Reviews",
            bilingual: "Bilingual — English & Español",
            airport: "5 Minutes from Las Vegas Airport",
            pmua: "Wendy Chester — PMUA · Advanced Esthetician",
            licensed: "Nevada State Licensed Studio",
        },
        home: {
            overline: "Permanent Makeup · Las Vegas",
            heroTitle: "Wake up with brows, lips and eyes that already look beautiful.",
            heroSub:
                "Premium permanent makeup by Wendy Chester, PMUA — nano brows, lip blushing, eyeliner tattoo and more. Bilingual studio just minutes from LAS.",
            seHabla: "Se habla español",
            ctaPrimary: "Book Your Appointment",
            ctaSecondary: "Explore Services",
            servicesOverline: "Signature Services",
            servicesTitle: "Crafted natural results that last for years.",
            servicesSub:
                "Every service begins with a private consultation to choose the technique, shape and shade that's right for your skin and lifestyle.",
            aboutOverline: "About Wendy",
            aboutTitle: "An artist obsessed with detail — and with you feeling like yourself.",
            aboutBody:
                "Wendy Chester is a PMUA and Advanced Esthetician with over a decade of experience perfecting permanent makeup for women across Las Vegas. Her work is known for natural hair-stroke nano brows, soft lip blushing and an honest, consultative approach. Atendemos a clientes en inglés y español — siempre.",
            aboutCta: "More about Wendy",
            reviewsOverline: "5.0 Stars on Google",
            reviewsTitle: "What our clients are saying.",
            galleryOverline: "Results",
            galleryTitle: "A look at recent work.",
            faqOverline: "Good to Know",
            ctaSectionTitle: "Ready when you are.",
            ctaSectionBody:
                "Reserve your consultation with a $50 deposit. We'll confirm appointment details, technique options and pricing during your visit.",
        },
        services: {
            nanoBrows: {
                title: "Nano Brows",
                overline: "Hair-Stroke · Machine Technique",
                subtitle:
                    "Crisp, natural hair strokes drawn with a single-needle nano machine — Wendy's signature.",
                description:
                    "Nano brows use an ultra-fine needle and a specialised machine to lay individual hair strokes into the skin. Unlike microblading, the technique works beautifully on combination and oily skin types because pigment is deposited cleanly and heals with less spread. The result reads like real brow hair, not a tattoo.",
                bestFor:
                    "Anyone wanting the most natural permanent brow available — especially oily, combination, or mature skin where microblading tends to blur.",
                pricing: "Pricing provided in consultation",
                duration: "2.5 – 3.5 hours",
                healing: "Color softens 30–40% as it heals · Touch-up at 6–8 weeks",
            },
            powderBrows: {
                title: "Powder Brows",
                overline: "Shaded · Machine Technique",
                subtitle:
                    "A soft, makeup-style finish — like beautifully filled-in brows from morning to night.",
                description:
                    "Powder brows shade pigment evenly into the brow using a stippling machine technique. Styles range from a soft ombré (lighter front, darker tail) to a fuller, defined finish. Pairs perfectly with nano brows as a 'hybrid' for the best of both worlds.",
                bestFor:
                    "Clients who love a polished, makeup-on look, or those with very sparse hair where strokes alone wouldn't fill the brow.",
                pricing: "Pricing provided in consultation",
                duration: "2 – 3 hours",
                healing: "Touch-up at 6–8 weeks",
            },
            lipBlushing: {
                title: "Lip Blushing",
                overline: "Color · Shape · Symmetry",
                subtitle:
                    "Subtle, healed tint that gives your natural lip color back — with a hint of definition.",
                description:
                    "Lip blushing softly tints the lip with a custom-mixed pigment to restore color, balance asymmetry and create the illusion of fuller lips. Healed results look like your lips, only freshly bitten — no lipliner required.",
                bestFor:
                    "Faded lip color, uneven shape, mature skin, or anyone tired of reapplying lipstick all day.",
                pricing: "Pricing provided in consultation",
                duration: "2.5 – 3 hours",
                healing: "Heals in ~7 days · Touch-up at 6–8 weeks",
            },
            microblading: {
                title: "Microblading",
                overline: "Hand-Tool · Hair Strokes",
                subtitle:
                    "Traditional hand-drawn brow strokes — offered selectively for the right skin type.",
                description:
                    "Microblading uses a manual blade to scratch hair strokes into the skin. It produces beautiful results on dry to normal skin but tends to blur on oily skin. Wendy offers microblading selectively after a thorough consultation; many clients are recommended nano brows instead for a longer-lasting, crisper result.",
                bestFor:
                    "Dry to normal skin clients who specifically prefer the hand-tool technique.",
                pricing: "Pricing provided in consultation",
                duration: "2.5 – 3 hours",
                healing: "Touch-up at 6–8 weeks · Consultation required",
            },
            eyelinerTattoo: {
                title: "Eyeliner Tattoo",
                overline: "Lash Line · Winged · Waterproof",
                subtitle: "Smudge-proof definition that wakes up your eyes — lash line enhancement or winged eyeliner.",
                description:
                    "Wendy offers two styles of permanent eyeliner: a subtle lash line enhancement that fills between the lashes for naturally denser-looking eyes, and a classic winged eyeliner for more dramatic definition. Both styles are waterproof and smudge-proof — no more daily liner application.",
                bestFor:
                    "Anyone tired of applying eyeliner daily, contact lens wearers, those with sensitive eyes, or anyone wanting lash line or winged eyeliner that never smudges.",
                pricing: "Pricing provided in consultation",
                duration: "1.5 – 2.5 hours",
                healing: "Heals in 5–7 days · Touch-up at 6–8 weeks",
            },
            browLamination: {
                title: "Brow Lamination",
                overline: "Non-Permanent · Reshape",
                subtitle:
                    "Lifts and sets your natural brow hairs for a fluffy, brushed-up look for 6–8 weeks.",
                description:
                    "Brow lamination is a perm and tint treatment that gently reshapes and lifts the brow hairs so they can be brushed into a fuller, more uniform shape. The tint adds depth and definition. Great as a stand-alone treatment or as a bridge between permanent makeup appointments.",
                bestFor:
                    "Unruly, sparse-looking or asymmetrical brows where the hairs are there but won't lie how you want.",
                pricing: "Pricing provided in consultation",
                duration: "45 – 60 minutes",
                healing: "Avoid water for 24 hours · Lasts 6–8 weeks",
            },
            comboBrows: {
                title: "Combo Brows",
                overline: "Nano + Powder · Best of Both",
                subtitle:
                    "The best of nano brows and powder brows combined — hair strokes in the front, soft shading in the body and tail.",
                description:
                    "Combo brows combine two techniques in one session: nano hair strokes through the front of the brow for a realistic, natural start, and powder shading through the body and tail for fullness and definition. The result is a brow that looks naturally full — hair-like in the front, softly filled toward the arch and tail.",
                bestFor:
                    "Clients who want the most natural-looking yet defined brow — especially those with sparse areas who love both the hair-stroke look and a polished finish.",
                pricing: "Pricing provided in consultation",
                duration: "2.5 – 3.5 hours",
                healing: "Color softens 30–40% as it heals · Touch-up at 6–8 weeks",
            },
            lashes: {
                title: "Lash Lifts",
                overline: "Lift · Curl · Define",
                subtitle:
                    "Natural lash lifts and tints — wake up with the curled, defined lashes you've been faking.",
                description:
                    "A lash lift gently curls and lifts your natural lashes from the root, creating the appearance of longer, more defined lashes without extensions. Pair it with a tint to darken and add depth for a low-maintenance, mascara-free look. Perfect for those who want beautiful lashes with zero daily effort.",
                bestFor:
                    "Anyone wanting curled, lifted lashes without extensions or daily mascara — ideal for natural beauty lovers and low-maintenance lifestyles.",
                pricing: "Pricing provided in consultation",
                duration: "45 min – 1 hour",
                healing: "Lasts 6–8 weeks · No fills required",
            },
            tattoos: {
                title: "Body Tattoos — Fine Line",
                overline: "Featured Artist · Elisha Lee",
                subtitle:
                    "Tiny tattoos and fine-line body art by resident artist Elisha Lee, inside Beauty Ink LV.",
                description:
                    "Our studio is also home to fine-line body tattoo artist Elisha Lee, specializing in tiny tattoos and delicate fine-line work. Whether it's a script piece, ornamental design, snake, butterfly or your first tiny tattoo, Elisha works in a clean, professional setting just minutes from the Las Vegas Strip and Harry Reid International Airport.",
                bestFor:
                    "Clients seeking delicate, minimalist tattoos with crisp lines and thoughtful placement. First-timers welcome.",
                pricing: "Pricing direct with Elisha Lee",
                duration: "30 min – several hours (design-dependent)",
                healing: "Standard tattoo aftercare provided · See Aftercare page",
            },
        },
        aftercare: {
            heroTitle: "Aftercare & Healing Guide",
            heroSub:
                "How you care for your skin in the first 14 days determines how beautifully your pigment heals. Follow these guidelines closely.",
            sections: [
                {
                    title: "Brows (Nano, Powder, Microblading)",
                    dos: [
                        "Gently blot any lymph/oozing with a clean tissue for the first 24 hours.",
                        "Apply a rice-grain amount of the provided ointment 2–3× per day for 7 days.",
                        "Sleep on your back if possible — keep brows off the pillow.",
                        "Drink plenty of water and let the skin heal naturally.",
                    ],
                    donts: [
                        "Do NOT get the area soaked in water for 10 days (no swimming, sauna, long showers).",
                        "Do NOT pick, scratch or rub flaking skin — let it shed naturally.",
                        "Avoid sweating heavily, sun exposure, retinoids and acids on the brow area for 14 days.",
                        "No makeup, brow products or facials over the area for 14 days.",
                    ],
                },
                {
                    title: "Lip Blushing",
                    dos: [
                        "Blot lips frequently in the first few hours to keep them dry.",
                        "Apply provided ointment every 1–2 hours for the first 3 days.",
                        "Drink through a straw and eat soft, neutral foods for several days.",
                        "Keep lips moisturised with provided balm until fully healed (~10 days).",
                    ],
                    donts: [
                        "No spicy, salty, citrus or very hot food/drinks for 7 days.",
                        "Do NOT pick at peeling lips — they will scab and shed in a few days.",
                        "No kissing, oral activity or strenuous sweat for 7–10 days.",
                        "Avoid toothpaste making direct contact — wipe lips before brushing.",
                    ],
                },
                {
                    title: "Eyeliner Tattoo",
                    dos: [
                        "Use cold compresses for the first 24 hours to reduce swelling.",
                        "Apply provided ointment with a clean cotton swab 2× daily for 5 days.",
                        "Sleep on your back with head slightly elevated.",
                        "Wear sunglasses outdoors during healing.",
                    ],
                    donts: [
                        "No eye makeup, mascara or lash extensions for 10 days.",
                        "No contact lenses for 24–48 hours (consult your eye doctor).",
                        "Do NOT rub or pick scabs — natural shedding only.",
                        "No pools, hot tubs or saunas for 10 days.",
                    ],
                },
            ],
            touchUp: {
                title: "Touch-Up Timeline",
                body:
                    "Every initial appointment includes a complimentary touch-up booked between weeks 6 and 8 after your first session. Annual color refreshes are recommended to maintain crisp, vibrant results.",
            },
        },
        bedRentals: {
            heroOverline: "For PMU Professionals",
            heroTitle: "Studio Beds & Chairs Available",
            heroSub:
                "Four beautifully appointed beds in a clean, licensed Las Vegas studio — selectively rented to PMU and beauty professionals who share our standards.",
            details: [
                {
                    label: "4 Beds Available",
                    body: "Each station fully equipped with adjustable bed, magnification, ring light and storage.",
                },
                {
                    label: "Half-Day & Full-Day",
                    body: "Half-day $50 · Full-day $75 · Weekly cap of $200 per renter — never more.",
                },
                {
                    label: "Selectively Screened",
                    body: "We screen every renter because Wendy is liable for the work performed in her studio.",
                },
                {
                    label: "Prime Location",
                    body: "5 minutes from Las Vegas Airport — easy for both clients and traveling artists.",
                },
            ],
            formTitle: "Inquire About a Bed",
            formNote:
                "Please share a bit about your experience and the services you offer. We'll be in touch to schedule a screening.",
        },
        training: {
            heroOverline: "Apprenticeship Program",
            heroTitle: "A 6-Month Apprenticeship for Serious Artists",
            heroSub:
                "Wendy takes on one to two apprentices per year, working closely with each over six months to refine their craft, business and client experience.",
            details: [
                {
                    label: "6-Month Curriculum",
                    body: "Hands-on training in nano brows, powder, lip blushing, eyeliner and aftercare protocols.",
                },
                {
                    label: "Highly Selective",
                    body: "Designed for licensed estheticians or artists with foundational PMU/tattoo experience.",
                },
                {
                    label: "One-on-One Mentorship",
                    body: "Direct shadowing of live appointments, portfolio building and business coaching.",
                },
                {
                    label: "Limited Spots",
                    body: "We currently accept one apprentice at a time to ensure quality of mentorship.",
                },
            ],
            afterTitle: "What Happens After You Graduate",
            afterCards: [
                {
                    title: "Rent a Bed at Beauty Ink LV",
                    body: "Graduates in good standing can rent a fully-equipped bed at the studio — half-day from $50, full-day $75, weekly capped at $200. You stay in a clean, licensed space with built-in client traffic from our location near LAS.",
                },
                {
                    title: "Build Your Own Brand",
                    body: "We help you set up your booking system, pricing structure, social presence and aftercare protocols so you're truly business-ready, not just technique-ready.",
                },
            ],
            payTitle: "What You Can Earn",
            payBody:
                "Established Las Vegas PMU artists typically charge $500–$1,200 per service (nano brows, lip blushing, eyeliner) and complete 8–15 services per week. Full-time PMU artists with a steady book commonly earn $80,000–$150,000+ per year, with top performers exceeding $200,000. Income depends on technique, marketing and consistency — all of which the apprenticeship is designed to develop.",
            payDisclaimer:
                "These figures reflect industry-typical ranges for licensed PMU professionals in Las Vegas. Individual results vary.",
            formTitle: "Apply for the Apprenticeship",
            formNote:
                "Tell us about your current background, your goals, and a link to any portfolio or social media you'd like us to see.",
        },
        contact: {
            heroOverline: "Get In Touch",
            heroTitle: "Visit the studio or send a note.",
            heroSub:
                "We respond to all inquiries within 1 business day. Use the booking widget below to schedule your appointment directly online.",
            formTitle: "Send a Message",
        },
        tattoosPage: {
            heroOverline: "Body Tattoo Studio · Near LAS Airport",
            heroTitle: "Fine line tattoos by Elisha Lee.",
            heroSub:
                "Our resident body tattoo artist Elisha Lee specializes in tiny tattoos and fine-line work inside the Beauty Ink LV studio — a clean, professional space just minutes from the airport and Las Vegas Strip.",
            artistOverline: "Featured Artist",
            artistName: "Elisha Lee",
            artistTitle: "Fine Line Tattoo Artist",
            artistSpecialty: "Specialty: Tiny Tattoos & Fine Line Tattoos",
            artistQuote:
                "Beauty Ink truly feels like home. The studio's aesthetic, décor and overall vibe make it such an amazing place to be. Wendy goes above and beyond to make sure both myself and my clients feel comfortable. The space is always spotless, well-stocked and organized — a welcoming environment that makes every experience enjoyable.",
            artistQuoteBy: "— Elisha Lee, Resident Tattoo Artist",
            galleryTitle: "Work by Elisha Lee",
            galleryOverline: "Portfolio",
            spaceTitle: "Tattoo Studio Space for Rent",
            spaceBody:
                "Beauty Ink also provides a professional space for seasoned body tattoo artists. Affordable bed rentals — rent daily full-time (6+ hrs) or daily part-time (5 hrs or less). Must hold an updated Body Art Card and Bloodborne Pathogen Certificate.",
            spaceCta: "Inquire About Renting",
            locationTitle: "Tattoo Studio Near Harry Reid International Airport",
            locationBody:
                "Convenient location near the airport and Las Vegas Strip on E. Tropicana Ave and Paradise Rd.",
            bookWithElisha: "Book with Elisha (DM)",
        },
        about: {
            heroOverline: "About",
            heroTitle: "Meet Wendy Chester",
            body1:
                "Wendy Chester is the founder of Beauty Ink LV, a PMUA and Advanced Esthetician licensed in Nevada. Over the past decade she has built a loyal Las Vegas clientele by combining technical precision with a warm, consultative approach.",
            body2:
                "Her signature is nano brows — fine machine-drawn hair strokes that look like real brow hair on every skin type. Beyond brows, she's an expert in lip blushing, eyeliner tattoo and aftercare-first protocols that keep results crisp for years.",
            body3:
                "Como artista bilingüe, Wendy atiende a clientes en inglés y español — siempre asegurándose de que entiendas cada paso del proceso.",
        },
    },
    es: {
        common: {
            bookNow: "Reservar Cita",
            bookConsultation: "Reservar Consulta",
            depositNote: "Depósito no reembolsable de $50",
            learnMore: "Saber Más",
            viewService: "Ver Servicio",
            gallery: "Galería",
            seeAllReviews: "Leer Todas las Reseñas",
            faqTitle: "Preguntas Frecuentes",
            phone: "Teléfono",
            address: "Dirección",
            hours: "Horario",
            email: "Correo",
            instagram: "Instagram",
            sendMessage: "Enviar Mensaje",
            submit: "Enviar Consulta",
            submitting: "Enviando…",
            thankYou: "Gracias — nos pondremos en contacto pronto.",
            errorSubmit: "Algo salió mal. Por favor intenta de nuevo o llámanos.",
            requiredField: "Obligatorio",
            optional: "Opcional",
            byAppointment: "Solo con cita",
        },
        nav: {
            home: "Inicio",
            services: "Servicios",
            nanoBrows: "Nano Cejas",
            powderBrows: "Powder Brows",
            lipBlushing: "Tinte de Labios",
            microblading: "Microblading",
            eyelinerTattoo: "Delineado Permanente",
            browLamination: "Laminado de Cejas",
            comboBrows: "Combo Brows",
            lashes: "Lifting de Pestañas",
            tattoos: "Tatuajes Corporales",
            aftercare: "Cuidado Posterior",
            bedRentals: "Renta de Camas",
            training: "Capacitación",
            about: "Nosotros",
            contact: "Contacto",
        },
        trust: {
            stars: "5.0 Estrellas · 30+ Reseñas en Google",
            bilingual: "Bilingüe — Inglés y Español",
            airport: "A 5 Minutos del Aeropuerto LAS",
            pmua: "Wendy Chester — PMUA · Esteticista Avanzada",
            licensed: "Estudio con Licencia del Estado de Nevada",
        },
        home: {
            overline: "Maquillaje Permanente · Las Vegas",
            heroTitle: "Despierta con cejas, labios y ojos perfectos.",
            heroSub:
                "Maquillaje permanente premium con Wendy Chester, PMUA — nano cejas, tinte de labios, delineado permanente y más. Estudio bilingüe a minutos del aeropuerto.",
            seHabla: "Se habla español",
            ctaPrimary: "Reserva tu Cita",
            ctaSecondary: "Ver Servicios",
            servicesOverline: "Servicios Insignia",
            servicesTitle: "Resultados naturales que duran años.",
            servicesSub:
                "Cada servicio comienza con una consulta privada para definir técnica, forma y tono ideales para tu piel y estilo de vida.",
            aboutOverline: "Sobre Wendy",
            aboutTitle: "Una artista obsesionada con el detalle — y con que te sientas tú misma.",
            aboutBody:
                "Wendy Chester es PMUA y Esteticista Avanzada con más de una década perfeccionando el maquillaje permanente para mujeres de Las Vegas. Es reconocida por sus nano cejas naturales pelo a pelo, tinte de labios y un enfoque honesto y consultivo. Atendemos en inglés y español — siempre.",
            aboutCta: "Conoce a Wendy",
            reviewsOverline: "5.0 Estrellas en Google",
            reviewsTitle: "Lo que dicen nuestras clientas.",
            galleryOverline: "Resultados",
            galleryTitle: "Trabajos recientes.",
            faqOverline: "Información Útil",
            ctaSectionTitle: "Cuando estés lista, estamos aquí.",
            ctaSectionBody:
                "Reserva tu consulta con un depósito de $50. Confirmaremos los detalles de la cita, técnicas y precios durante tu visita.",
        },
        services: {
            nanoBrows: {
                title: "Nano Cejas",
                overline: "Pelo a Pelo · Técnica con Máquina",
                subtitle:
                    "Trazos finos y naturales con una nano máquina de aguja única — la especialidad de Wendy.",
                description:
                    "Las nano cejas utilizan una aguja ultra fina y una máquina especializada para crear cada pelito de forma individual. A diferencia del microblading, esta técnica funciona muy bien en piel mixta y grasa, depositando el pigmento de forma limpia y curando sin difuminarse. El resultado se ve como vello real, no como un tatuaje.",
                bestFor:
                    "Cualquier persona que busque la ceja permanente más natural — especialmente piel grasa, mixta o madura donde el microblading tiende a borrarse.",
                pricing: "Precio durante la consulta",
                duration: "2.5 – 3.5 horas",
                healing: "El color suaviza 30–40% al curar · Retoque a 6–8 semanas",
            },
            powderBrows: {
                title: "Powder Brows",
                overline: "Sombreado · Técnica con Máquina",
                subtitle: "Un acabado tipo maquillaje — cejas perfectamente rellenas todo el día.",
                description:
                    "Las powder brows sombrean el pigmento de forma pareja con técnica de máquina. Los estilos van desde un ombré suave (más claro al inicio, más oscuro hacia la cola) hasta un acabado lleno y definido. Combinan perfecto con nano cejas en un estilo 'híbrido'.",
                bestFor:
                    "Clientas que aman un look pulido y maquillado, o con muy poco vello donde los trazos no llenarían la ceja.",
                pricing: "Precio durante la consulta",
                duration: "2 – 3 horas",
                healing: "Retoque a 6–8 semanas",
            },
            lipBlushing: {
                title: "Tinte de Labios",
                overline: "Color · Forma · Simetría",
                subtitle:
                    "Un tinte sutil que devuelve color y definición natural a tus labios.",
                description:
                    "El lip blushing pigmenta los labios suavemente con un tono personalizado para recuperar color, equilibrar asimetrías y crear la ilusión de labios más llenos. Los resultados ya curados se ven como tus labios — pero recién mordidos. Sin necesidad de delineador.",
                bestFor:
                    "Labios pálidos o desiguales, piel madura, o cualquiera cansada de retocar el lápiz labial todo el día.",
                pricing: "Precio durante la consulta",
                duration: "2.5 – 3 horas",
                healing: "Cura en ~7 días · Retoque a 6–8 semanas",
            },
            microblading: {
                title: "Microblading",
                overline: "Manual · Pelo a Pelo",
                subtitle:
                    "Técnica tradicional manual — ofrecida selectivamente según tu tipo de piel.",
                description:
                    "El microblading utiliza una cuchilla manual para crear trazos pelo a pelo. Produce hermosos resultados en piel seca a normal, pero tiende a difuminarse en piel grasa. Wendy ofrece microblading de manera selectiva tras una consulta cuidadosa; muchas clientas reciben la recomendación de nano cejas para un resultado más duradero.",
                bestFor: "Piel seca a normal y clientas que prefieren la técnica manual.",
                pricing: "Precio durante la consulta",
                duration: "2.5 – 3 horas",
                healing: "Retoque a 6–8 semanas · Consulta requerida",
            },
            eyelinerTattoo: {
                title: "Delineado Permanente",
                overline: "Línea de Pestañas · Alado · A Prueba de Agua",
                subtitle:
                    "Definición sin manchas que despierta tu mirada — realce de línea de pestañas o delineado alado.",
                description:
                    "Wendy ofrece dos estilos de delineado permanente: un sutil realce de línea de pestañas que rellena entre las pestañas para ojos más definidos de forma natural, y un delineado alado clásico para una definición más dramática. Ambos estilos son a prueba de agua y manchas — sin necesidad de aplicar delineador diariamente.",
                bestFor:
                    "Quien se cansa del delineado diario, usuarias de lentes de contacto, con ojos sensibles, o quien desee delineado que nunca se corre.",
                pricing: "Precio durante la consulta",
                duration: "1.5 – 2.5 horas",
                healing: "Cura en 5–7 días · Retoque a 6–8 semanas",
            },
            browLamination: {
                title: "Laminado de Cejas",
                overline: "No Permanente · Reformar",
                subtitle:
                    "Levanta y fija el vello natural para una ceja peinada hacia arriba por 6–8 semanas.",
                description:
                    "El laminado de cejas es un tratamiento de permanente y tinte que suavemente levanta y remodela el vello para peinarlo en una forma más completa y uniforme. El tinte agrega profundidad y definición. Excelente como tratamiento individual o entre citas de maquillaje permanente.",
                bestFor:
                    "Cejas rebeldes, ralas o asimétricas donde el vello existe pero no se queda como quieres.",
                pricing: "Precio durante la consulta",
                duration: "45 – 60 minutos",
                healing: "Evita agua por 24 horas · Dura 6–8 semanas",
            },
            comboBrows: {
                title: "Combo Brows",
                overline: "Nano + Powder · Lo Mejor de Ambos",
                subtitle:
                    "Lo mejor de nano y powder brows combinados — trazos pelo a pelo al frente, sombreado suave en el cuerpo y cola.",
                description:
                    "Las combo brows combinan dos técnicas en una sesión: trazos nano pelo a pelo en la parte frontal de la ceja para un inicio realista y natural, y sombreado powder en el cuerpo y cola para plenitud y definición. El resultado es una ceja que se ve naturalmente llena — como pelo real al frente, suavemente rellena hacia el arco y cola.",
                bestFor:
                    "Clientas que buscan la ceja más natural pero definida — especialmente con zonas escasas que aman tanto los trazos pelo a pelo como un acabado pulido.",
                pricing: "Precio durante la consulta",
                duration: "2.5 – 3.5 horas",
                healing: "El color suaviza 30–40% al curar · Retoque a 6–8 semanas",
            },
            lashes: {
                title: "Lifting de Pestañas",
                overline: "Rizar · Levantar · Definir",
                subtitle:
                    "Lifting y tinte de pestañas — despierta con pestañas rizadas y definidas de forma natural.",
                description:
                    "El lifting de pestañas riza y levanta suavemente tus pestañas naturales desde la raíz, creando la apariencia de pestañas más largas y definidas sin extensiones. Combínalo con un tinte para oscurecer y agregar profundidad para un look de bajo mantenimiento sin máscara. Perfecto para quienes desean pestañas hermosas sin esfuerzo diario.",
                bestFor:
                    "Quien busque pestañas rizadas y levantadas sin extensiones ni máscara diaria — ideal para amantes de la belleza natural y estilos de vida de bajo mantenimiento.",
                pricing: "Precio durante la consulta",
                duration: "45 min – 1 hora",
                healing: "Dura 6–8 semanas · Sin rellenos necesarios",
            },
            tattoos: {
                title: "Tatuajes — Línea Fina",
                overline: "Artista Residente · Elisha Lee",
                subtitle:
                    "Tatuajes pequeños y de línea fina por la artista residente Elisha Lee, en Beauty Ink LV.",
                description:
                    "Nuestro estudio también es hogar de la artista de tatuaje corporal Elisha Lee, especializada en tatuajes pequeños y delicados de línea fina. Ya sea letra cursiva, diseño ornamental, serpiente, mariposa o tu primer tatuaje pequeño, Elisha trabaja en un ambiente limpio y profesional a minutos del Strip y del Aeropuerto Harry Reid.",
                bestFor:
                    "Clientes que buscan tatuajes delicados y minimalistas con líneas nítidas. Primerizos bienvenidos.",
                pricing: "Precio directo con Elisha Lee",
                duration: "30 min – varias horas (depende del diseño)",
                healing: "Cuidado posterior estándar · Ver página de Cuidado Posterior",
            },
        },
        aftercare: {
            heroTitle: "Guía de Cuidado Posterior",
            heroSub:
                "Cómo cuidas tu piel los primeros 14 días determina cómo cura el pigmento. Sigue estas indicaciones cuidadosamente.",
            sections: [
                {
                    title: "Cejas (Nano, Powder, Microblading)",
                    dos: [
                        "Limpia suavemente cualquier secreción con un pañuelo limpio durante las primeras 24 horas.",
                        "Aplica una cantidad mínima del ungüento provisto 2–3× al día por 7 días.",
                        "Duerme boca arriba si puedes — mantén las cejas alejadas de la almohada.",
                        "Toma mucha agua y permite que la piel sane naturalmente.",
                    ],
                    donts: [
                        "NO sumerjas la zona en agua por 10 días (sin piscina, sauna, baños largos).",
                        "NO te rasques ni jales las costras — déjalas caer solas.",
                        "Evita sudoración intensa, sol, retinoides y ácidos por 14 días.",
                        "Sin maquillaje, productos para cejas o faciales por 14 días.",
                    ],
                },
                {
                    title: "Tinte de Labios",
                    dos: [
                        "Seca los labios con frecuencia en las primeras horas.",
                        "Aplica el ungüento cada 1–2 horas los primeros 3 días.",
                        "Usa popote y come alimentos suaves y neutros varios días.",
                        "Mantén los labios humectados con el bálsamo provisto hasta cicatrizar (~10 días).",
                    ],
                    donts: [
                        "Sin alimentos picantes, salados, cítricos ni muy calientes por 7 días.",
                        "NO toques las costras — caerán solas en días.",
                        "Sin besos ni esfuerzo físico fuerte por 7–10 días.",
                        "Evita el contacto directo con pasta de dientes — limpia antes de cepillar.",
                    ],
                },
                {
                    title: "Delineado Permanente",
                    dos: [
                        "Usa compresas frías las primeras 24 horas para reducir hinchazón.",
                        "Aplica ungüento con hisopo limpio 2× al día por 5 días.",
                        "Duerme boca arriba con la cabeza ligeramente elevada.",
                        "Usa lentes de sol al aire libre durante la curación.",
                    ],
                    donts: [
                        "Sin maquillaje de ojos, máscara ni extensiones por 10 días.",
                        "Sin lentes de contacto por 24–48 horas (consulta con tu optometrista).",
                        "NO frotes ni piques las costras.",
                        "Sin piscinas, jacuzzis ni saunas por 10 días.",
                    ],
                },
            ],
            touchUp: {
                title: "Cronograma de Retoque",
                body:
                    "Cada cita inicial incluye un retoque de cortesía agendado entre la semana 6 y 8 después de tu primera sesión. Se recomienda un retoque anual para mantener resultados nítidos y vibrantes.",
            },
        },
        bedRentals: {
            heroOverline: "Para Profesionales PMU",
            heroTitle: "Camas y Sillas de Estudio Disponibles",
            heroSub:
                "Cuatro estaciones bien equipadas en un estudio limpio y con licencia en Las Vegas — rentadas selectivamente a profesionales que comparten nuestros estándares.",
            details: [
                {
                    label: "4 Camas Disponibles",
                    body: "Cada estación equipada con cama ajustable, lupa, aro de luz y almacenamiento.",
                },
                {
                    label: "Medio Día y Día Completo",
                    body: "Medio día $50 · Día completo $75 · Tope semanal de $200 por rentadora — nunca más.",
                },
                {
                    label: "Selección Cuidadosa",
                    body: "Filtramos a cada rentadora porque Wendy es responsable del trabajo en su estudio.",
                },
                {
                    label: "Ubicación Privilegiada",
                    body: "A 5 minutos del Aeropuerto LAS — ideal para clientes y artistas viajeras.",
                },
            ],
            formTitle: "Solicita una Cama",
            formNote:
                "Cuéntanos un poco sobre tu experiencia y los servicios que ofreces. Nos pondremos en contacto para agendar una entrevista.",
        },
        training: {
            heroOverline: "Programa de Aprendizaje",
            heroTitle: "Aprendizaje de 6 Meses para Artistas Serias",
            heroSub:
                "Wendy toma una o dos aprendices por año, trabajando de cerca con cada una durante seis meses para perfeccionar su técnica, negocio y experiencia con clientes.",
            details: [
                {
                    label: "Plan de 6 Meses",
                    body: "Entrenamiento práctico en nano cejas, powder, labios, delineado y protocolos de cuidado.",
                },
                {
                    label: "Altamente Selectivo",
                    body: "Diseñado para esteticistas con licencia o artistas con experiencia previa en PMU/tatuaje.",
                },
                {
                    label: "Mentoría 1-a-1",
                    body: "Observación directa de citas, construcción de portafolio y coaching de negocio.",
                },
                {
                    label: "Cupos Limitados",
                    body: "Actualmente aceptamos una aprendiz a la vez para garantizar la calidad.",
                },
            ],
            afterTitle: "Qué Sucede Después de Graduarte",
            afterCards: [
                {
                    title: "Renta una Cama en Beauty Ink LV",
                    body: "Las graduadas en buenas condiciones pueden rentar una cama totalmente equipada en el estudio — medio día desde $50, día completo $75, semanal con tope de $200. Trabajas en un espacio limpio, con licencia y tráfico de clientes cerca del aeropuerto.",
                },
                {
                    title: "Construye Tu Marca",
                    body: "Te ayudamos a configurar tu sistema de reservas, precios, presencia en redes sociales y protocolos de cuidado para que estés lista no solo en técnica, sino como negocio.",
                },
            ],
            payTitle: "Lo Que Puedes Ganar",
            payBody:
                "Las artistas de PMU establecidas en Las Vegas suelen cobrar entre $500 y $1,200 por servicio (nano cejas, tinte de labios, delineado) y completan entre 8 y 15 servicios por semana. Artistas de tiempo completo con agenda estable comúnmente ganan entre $80,000 y $150,000+ al año, con las mejores superando los $200,000. Los ingresos dependen de la técnica, marketing y consistencia — todo lo que se desarrolla en el aprendizaje.",
            payDisclaimer:
                "Estas cifras reflejan rangos típicos para profesionales de PMU con licencia en Las Vegas. Los resultados individuales varían.",
            formTitle: "Aplicar al Programa",
            formNote:
                "Cuéntanos sobre tu experiencia actual, tus metas y un enlace a tu portafolio o redes sociales.",
        },
        contact: {
            heroOverline: "Contáctanos",
            heroTitle: "Visita el estudio o envía un mensaje.",
            heroSub:
                "Respondemos todas las consultas en un día hábil. Usa el widget de reservas a continuación para agendar tu cita directamente en línea.",
            formTitle: "Envía un Mensaje",
        },
        tattoosPage: {
            heroOverline: "Estudio de Tatuajes · Cerca del Aeropuerto LAS",
            heroTitle: "Tatuajes de línea fina con Elisha Lee.",
            heroSub:
                "Nuestra artista residente Elisha Lee se especializa en tatuajes pequeños y de línea fina dentro del estudio Beauty Ink LV — un espacio limpio y profesional a minutos del aeropuerto y del Strip.",
            artistOverline: "Artista Destacada",
            artistName: "Elisha Lee",
            artistTitle: "Tatuadora de Línea Fina",
            artistSpecialty: "Especialidad: Tatuajes Pequeños y de Línea Fina",
            artistQuote:
                "Beauty Ink realmente se siente como hogar. La estética del estudio, la decoración y el ambiente lo hacen un lugar increíble. Wendy se esfuerza para que tanto yo como mis clientes nos sintamos cómodos. El espacio siempre está impecable, bien equipado y organizado — un ambiente acogedor.",
            artistQuoteBy: "— Elisha Lee, Tatuadora Residente",
            galleryTitle: "Trabajos de Elisha Lee",
            galleryOverline: "Portafolio",
            spaceTitle: "Espacio de Tatuaje para Rentar",
            spaceBody:
                "Beauty Ink también ofrece un espacio profesional para tatuadores corporales con experiencia. Renta accesible — diaria de tiempo completo (6+ hrs) o tiempo parcial (5 hrs o menos). Debe contar con Body Art Card y certificado de Patógenos Sanguíneos vigentes.",
            spaceCta: "Solicita Información",
            locationTitle: "Estudio de Tatuaje Cerca del Aeropuerto",
            locationBody:
                "Ubicación conveniente cerca del aeropuerto y del Strip en E. Tropicana Ave y Paradise Rd.",
            bookWithElisha: "Reserva con Elisha (DM)",
        },
        about: {
            heroOverline: "Nosotros",
            heroTitle: "Conoce a Wendy Chester",
            body1:
                "Wendy Chester es la fundadora de Beauty Ink LV, PMUA y Esteticista Avanzada con licencia en Nevada. Durante la última década ha construido una clientela leal en Las Vegas combinando precisión técnica con un enfoque cálido y consultivo.",
            body2:
                "Su firma son las nano cejas — finos trazos de máquina pelo a pelo que se ven como vello real en cualquier tipo de piel. Más allá de las cejas, es experta en tinte de labios, delineado permanente y protocolos de cuidado posterior.",
            body3:
                "Como artista bilingüe, Wendy atiende clientes en inglés y español — siempre asegurándose de que entiendas cada paso del proceso.",
        },
    },
};
